import { database } from "../firebase";
import { ref, onValue, set, remove } from "firebase/database";


class UsersDataService {

    create(data) {
        return set(ref(database, 'users/' + data.userName), data);
    }

    /**
     * Listener de todos los usuarios (Realtime Database).
     * @param {function} callback - Recibe array de usuarios { userName, email, rol, ... }
     */
    getAll(callback) {
        const usersRef = ref(database, 'users');
        return onValue(usersRef, (snapshot) => {
            const data = snapshot.val();
            const list = data
                ? Object.entries(data).map(([key, val]) => ({
                    ...val,
                    userName: val.userName != null ? val.userName : key
                  }))
                : [];
            callback(list);
        });
    }

    /**
     * Elimina un usuario por userName (Realtime Database).
     */
    remove(userName) {
        return remove(ref(database, 'users/' + userName));
    }
}

export default new UsersDataService();
